//----------------------------------
// Imports
//----------------------------------
import Vue from 'vue';
import api from './api';
import config from './config';

const { APP_ENV, APP_CONTENT_URL, LANGUAGES, APP_VERSION } = config;
const reactiveVm = new Vue({ data: { savData: null, clientWidth: window.innerWidth } });
const sav = {
  api,
  env: APP_ENV,
  version: APP_VERSION,
  contentUrl: (APP_CONTENT_URL === '/') ? '' : APP_CONTENT_URL,
  languages: LANGUAGES,
  install: () => {
    Object.defineProperty(sav, 'data', {
      get() { return reactiveVm.savData; },
      set(value) { reactiveVm.savData = value; },
    });
    Object.defineProperty(Vue.prototype, '$sav', {
      get() { return sav; },
    });
    Object.defineProperty(sav, 'clientWidth', {
      get() { return reactiveVm.clientWidth; },
    });
    window.onresize = () => {
      reactiveVm.clientWidth = window.innerWidth;
    };
    // remove method so we don't expose it after it has been used
    delete sav.install;
  },
};

Vue.use(sav);

export default sav;
